import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.lazy)
    ? (_openBlock(), _createBlock(_component_AutoComplete, {
        key: 0,
        modelValue: _ctx.selectedTaxon,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTaxon) = $event)),
        "force-selection": "",
        suggestions: _ctx.filteredItems,
        onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems($event))),
        onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.select($event.value.ID))),
        optionLabel: "LABEL",
        optionValue: "ID",
        virtualScrollerOptions: { itemSize: 100 },
        field: "LABEL",
        dropdown: "",
        placeholder: _ctx.$t('choose_dropdown'),
        filterPlaceholder: _ctx.$t('search'),
        class: "p-mb-2",
        showClear: _ctx.clearable
      }, null, 8, ["modelValue", "suggestions", "placeholder", "filterPlaceholder", "showClear"]))
    : (_openBlock(), _createBlock(_component_Dropdown, {
        key: 1,
        modelValue: _ctx.selected,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected) = $event)),
        options: _ctx.options,
        optionLabel: "LABEL",
        optionValue: "ID",
        placeholder: _ctx.$t('choose_dropdown'),
        filter: _ctx.filter,
        filterPlaceholder: _ctx.$t('search'),
        class: "p-mb-2",
        showClear: _ctx.clearable,
        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.select($event.value)))
      }, null, 8, ["modelValue", "options", "placeholder", "filter", "filterPlaceholder", "showClear"]))
}